import React from "react";
class ContextMenuItem extends React.Component {

    render() {
        const {Name, Icon, OnClick } = this.props;
        return (
            <li className="context-menu__item" onClick={(ev) => {OnClick(ev)}} style={{cursor: "pointer"}}>
                <span className="context-menu__link">
                    {Icon &&
                        <span className="svg-icon menu-icon nav-icon active svg-icon-success mr-3">
                            <i className={`svg-icon svg-icon-sm text-primary ${Icon}`}> </i>
                        </span>
                    }
                    {Name}
                </span>
            </li>
        );
    }
}

export default ContextMenuItem;
